import React, { Component } from 'react'
import ErrorScreen from 'components/common/errorScreen'
import { api } from '../../network/api'
import { logsUrl } from './url'

class ErrorBoundary extends Component {
    constructor(props) {
        super(props)
        this.state = { hasError: false, error: {} }
    }

    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return { hasError: true, error: error }
    }

    componentDidCatch(error, info) {
        const data = {
            message: `${error} *** ${error?.toString()}||${info?.componentStack}`,
            logLevel: 'error',
            loggedBy: 'webAppUI',
        }
        api(logsUrl, 'POST', data).catch(() => {
            // Silently ignore logging failures
        })
    }

    render() {
        if (this.state.hasError) {
            // rendering custom fallback UI
            return <ErrorScreen renderFailure />
        }
        return this.props.children
    }
}

export default ErrorBoundary
